import { http, HttpResponse } from 'msw'

import { allSubcategories } from 'app/mocks/data/catalogue/products/subcategories'

import { api } from 'app/utils/constants'

import { CategoryProductRequest } from 'app/types/catalogue/product/category'

export const getAllSubcategoriesProduct = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.catalogue.products.subcategories.LIST}`,
    () => {
        return HttpResponse.json<CategoryProductRequest>({
            results: allSubcategories,
        })
    },
)
